"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pimonte": {
    "36f6c39d": [{
      "hkey": "91ffb7c5",
      "slug": "pimonte",
      "name": "Pimonte",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "91ffb7c5",
      "slug": "pimonte",
      "name": "Pimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "89a9ed71": [{
      "hkey": "91ffb7c5",
      "slug": "pimonte",
      "name": "Pimonte",
      "primary": true,
      "skipSearch": false
    }],
    "franche": [{
      "hkey": "91ffb7c5",
      "slug": "pimonte",
      "name": "Pimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6465c322": [{
      "hkey": "91ffb7c5",
      "slug": "pimonte",
      "name": "Pimonte",
      "primary": true,
      "skipSearch": false
    }],
    "tralia": [{
      "hkey": "91ffb7c5",
      "slug": "pimonte",
      "name": "Pimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;